module.exports = __webpack_public_path__ + "way2go/static/config/b8_after_facenorth.png";